'use client';

import { c as _c } from "react/compiler-runtime";
import { Heart } from '@sprd/sprd-component-kit/v2';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { useFavorites } from '@/hooks/useFavorites';
import { useIsClient } from '@/hooks/useIsClient';
import { Link } from '@/i18n/navigation';
export const FavoritesPageLink = () => {
  const $ = _c(12);
  const {
    data: favorites
  } = useFavorites();
  const t = useTranslations("favorites");
  const isClient = useIsClient();
  const totalQuantity = isClient && favorites ? favorites.length : 0;
  let t0;
  if ($[0] !== t) {
    t0 = t("page");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Heart className="size-6" aria-hidden={true} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = totalQuantity > 99 ? "-right-3" : "-right-1";
  const t3 = totalQuantity === 0 ? "hidden" : "";
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = clsx("absolute -top-1 flex h-5 min-w-5 items-center justify-center rounded-l-xl rounded-r-xl bg-black px-1 text-xs text-white", t2, t3);
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = totalQuantity > 99 ? "99+" : totalQuantity;
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <span aria-hidden={true} className={t4}>{t5}</span>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t0 || $[10] !== t6) {
    t7 = <Link href="/favorites" className="relative inline-flex min-h-8 w-10 shrink-0 items-center justify-center px-2 py-2 font-semibold" aria-label={t0}>{t1}{t6}</Link>;
    $[9] = t0;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};